import React, { FunctionComponent } from 'react'
import clsx from 'clsx'
import { warn } from '../utils/console'

import styles from './style.module.scss'
import { useThemeClass } from '../Theme'

interface Props {
  testNameSpace?: string
  percent?: number
  'aria-label'?: string
  'aria-labelledby'?: string
}

export const ProgressBar: FunctionComponent<Props> = ({ testNameSpace = '', percent = 0, ...otherProps }) => {
  const hasTestId = testNameSpace.length > 0
  const themeClass = useThemeClass()
  const classes = clsx(styles.progressBar, styles[themeClass])

  if (percent > 100 || percent < 0) {
    warn(`[Core - ProgressBar] Percent property ranged from 0 to 100. `)
  }

  const clampedRoundedPercent = Math.min(100, Math.max(0, Math.round(percent)))
  const fillStyle = clsx(styles.fill, styles[`fill-${clampedRoundedPercent}`])

  return (
    <div
      role='progressbar'
      aria-valuenow={percent}
      className={classes}
      {...(hasTestId && { 'data-testid': `${testNameSpace}-progressBar` })}
      title={otherProps['aria-label'] ?? 'Progress Bar'}
      {...otherProps}
    >
      <div className={styles.fillMask}>
        <div className={fillStyle} {...(hasTestId && { 'data-testid': `${testNameSpace}-progressBar-fill` })}></div>
      </div>
    </div>
  )
}
